'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentWithWindowListeners = {
  componentDidMount: function componentDidMount() {
    (0, _invariant2.default)(typeof this.getWindowListeners === 'function', 'ComponentWithWindowListeners: component must define' + ' a getWindowListeners function.');
    this._componentMountedWindowListener = true;
    this._windowListeners = this.getWindowListeners();
    if (this.shouldBindWindowListeners()) {
      this.bindWindowListeners();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._componentMountedWindowListener = false;
    this.unbindWindowListeners();
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.shouldBindWindowListeners()) {
      this.bindWindowListeners();
    } else {
      this.unbindWindowListeners();
    }
  },
  bindWindowListeners: function bindWindowListeners() {
    if (this._windowListenersBound) {
      return;
    }

    var windowListeners = this._windowListeners;
    Object.keys(windowListeners).forEach(function (eventName) {
      window.addEventListener(eventName, windowListeners[eventName]);
    });
    this._windowListenersBound = true;
  },
  unbindWindowListeners: function unbindWindowListeners() {
    if (!this._windowListenersBound) {
      return;
    }

    var windowListeners = this._windowListeners;
    Object.keys(windowListeners).forEach(function (eventName) {
      window.removeEventListener(eventName, windowListeners[eventName]);
    });
    this._windowListenersBound = false;
  },
  shouldBindWindowListeners: function shouldBindWindowListeners() {
    if (!this._componentMountedWindowListener) {
      // It's apparently possible for componentDidUpdate() to be called after
      // componentWillUnmount(). See #2287
      return false;
    }
    var getWindowListenersActive = this.getWindowListenersActive;

    var hasActiveCondition = typeof getWindowListenersActive === 'function';
    return hasActiveCondition ? getWindowListenersActive() : true;
  }
};

exports.default = ComponentWithWindowListeners;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/mixins/ComponentWithWindowListeners.js
// module id = 945
// module chunks = 2 3